import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Table from '../../components/Table/Table';
import TablePagination from '../../components/TablePagination/TablePagination';
import { Sort } from '../../models/CommonModels';
import { RootState } from '../../stores/Store';
import DevicesReportFilters from './DevicesReportFilters';
import useDevicesReportTable from './useDevicesReportTable';

interface DevicesReportProps {
  unassignedReport: boolean;
}

function DevicesReportTable({ unassignedReport }: DevicesReportProps) {
  const [t] = useTranslation();
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sort, setSort] = useState<Sort>({
    order: 'asc',
    orderBy: !unassignedReport ? 'endUserLastName' : 'manufacturer',
  });
  const filter = useSelector((state: RootState) => state.devicesReportReducer.filter);
  const { headers, rows, totalItems, isLoading, exportData } = useDevicesReportTable(
    activePage,
    pageSize,
    filter,
    sort,
    unassignedReport,
  );

  /**
   * On pagination change
   * Perform a new request
   * @param page
   * @param pSize
   */
  const handlePaginationChange = (page: number, pSize: number) => {
    setActivePage(page);
    setPageSize(pSize);
  };

  /**
   * Handle change of the table sort
   * @param s
   */
  const handleOnSort = (s: Sort) => {
    setSort(s);
  };

  useEffect(() => {
    setActivePage(1);
  }, [filter]);

  return (
    <Box paddingBottom="3rem">
      {!unassignedReport ? (
        <DevicesReportFilters isLoading={isLoading} exportData={exportData} totalItems={totalItems} />
      ) : null}
      <Typography variant="body1" paddingTop={unassignedReport ? '1.5rem' : '0'} paddingBottom="1rem">
        {t('common.table.totalItems', { count: totalItems })}
      </Typography>
      <Table headers={headers} rows={rows} isLoading={isLoading} defaultOrderBy={sort.orderBy} onSort={handleOnSort} />
      <TablePagination
        activePage={activePage}
        pageSize={pageSize}
        totalItems={totalItems}
        handlePageChange={handlePaginationChange}
      />
    </Box>
  );
}

export default DevicesReportTable;
